export default __webpack_public_path__ + "static/media/Withholding-tax-rules.dbaf07c3.svg";